import React from 'react';
import { ResponseSorts } from '../../components/creator-report/ResponseSorts';
import ResponsesList from '../../components/creator-report/ResponsesList';
import Event from '../../models/Event';
import { EventQuestionType } from '../../models/EventQuestionType';
import AverageBreakdown from '../../components/creator-report/AverageBreakdown';

export class DeetList extends React.Component {

  getTopList = (ideas) => {
    const topListLength = 5;
    const hasResponses = (ideas && ideas.length > 0);
    return hasResponses ? ResponseSorts.getTopRanked(ideas, topListLength) : [];
  }

  renderEvent = (event, eventStats, ideas) => {
    let renderMe;
    if (EventQuestionType.isOpenEndedType(Event.getQuestionType(event))) {
      renderMe = (
        <ResponsesList
          key={ Event.getId(event) }
          onItemClicked={ () => { } }
          event={ event }
          isTopRank={ true }
          isAllResponsesEnabled={ false }
          responses={ this.getTopList(ideas) }
          scrollingOffset={ 0 } />
      );
    } else {
      renderMe = (
        <AverageBreakdown id={ Event.getId(event) } event={ event } stats={ eventStats } ideas={ ideas } padding={ true } />
      );
    }

    return renderMe;
  }

  render () {
    const { event, eventStats, ideas } = this.props;
    return (
      <div className="deet-list" style={{
        marginLeft: '-1rem',
        marginRight: '-1rem'
      }}>
        { this.renderEvent(event, eventStats, ideas) }
      </div>
    );
  }
}